import layout from '@/layout'
const meta = { auth: true, cache: true, head: { back: true } }

export default {
  path: '/inspection',
  component: layout,
  meta: {
    funcID: 'F0014',
    PID: 'F00',
  },
  children: ((pre) => [
    {
      path: 'defects',
      name: `${pre}defects`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'F001401',
        PID: 'F00',
      },
      component: () => import('@/views/factory/inspection/defects'),
    },
    {
      path: 'defects/:pageType/:code?',
      name: `${pre}defects-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { dfDefinitionNo = '' } = $route.query || {}
          return `疵点标准定义 | ${dfDefinitionNo || '新增'}`
        },
        funcID: 'F001401',
        PID: 'F00',
      },
      component: () => import('@/views/factory/inspection/defects/detail'),
    },
    {
      path: 'inspector',
      name: `${pre}inspector`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'F001402',
        PID: 'F00',
      },
      component: () => import('@/views/factory/inspection/inspector'),
    },
    {
      path: 'apply',
      name: `${pre}apply`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'F001403',
        PID: 'F00'
      },
      component: () => import('@/views/factory/inspection/apply')
    },
    {
      path: 'apply/:pageType/:code?',
      name: `${pre}apply-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { applyNo = '' } = $route.query || {}
          return `订单验货申请 | ${applyNo || '新增'}`
        },
        funcID: 'F001403',
        PID: 'F00',
        pageConfig: {
          layout: { class: 'bg-transparent p-0', bodyClass: 'p-0 m-0' },
        },
      },
      component: () => import('@/views/factory/inspection/apply/detail'),
    },
    {
      path: 'workshop',
      name: `${pre}workshop`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'F001404',
        PID: 'F00',
      },
      component: () => import('@/views/factory/inspection/workshop'),
    },
  ])('inspection-')
}
